Vue.component('bus-item', {
    props: ['bus'],
    data: function () {
        return {
            nightText: ['js.bus.night.sunday.monday', 'js.bus.night.monday.tuesday', 'js.bus.night.tuesday.wednesday', 'js.bus.night.wednesday.thursday', 'js.bus.night.thursday.friday', 'js.bus.night.friday.saturday', 'js.bus.night.saturday.sunday'],
            trip: {
                hour: 0,
                minute: 0,
            },
            availableText: FmtMessage.getMessage('js.bus.search.last.availableSeat'),
            textHours: '',
            textMinutes:''
        }
    },
    created: function(){
        this.setTripTime(this.bus.busTime)
        this.textHours = FmtMessage.getMessage('js.time.hour');
        this.textMinutes = FmtMessage.getMessage('js.time.minute');
        this.$nextTick(function() {
         	  $( '.titleTip' ).tipTip();
  		});	
    },
    computed: {
    	
        lastAvailableSeatCountText: function () {
            if (this.availableText){
                var fmt = this.availableText;
                return fmt.replace("{0}", this.bus.emptySeatNumber)
            }
            return '';
        },
        nightDepartureText: function () {
            var departure = new Date(this.bus.departureDate);
            if (departure.getHours() < 5){
                var day = departure.getDay();
                if (day == 0){
                    day = this.nightText.length - 1;
                }
                else {
                    day = day - 1;
                }
                return FmtMessage.getMessage(this.nightText[day]);
            }
            return "";
        }
    },
    methods: {
        formatTime: function (date) {
            date = new Date(date);
            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            var mins = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();

            return hours + ':' + mins;
        },
        setTripTime: function(val){
            var totalMins = val / 60;
            var hours = Math.floor(totalMins / 60);
            var mins = totalMins - (hours * 60);
            this.trip = {
                hour: hours,
                minute: mins
            };
        },
        openBusDetail: function () {
        	this.$emit('select',this.bus);
        },
        getTicketPrice : function(){
        	return currencyFormat(this.bus.ticketPriceWeb);
        }
    },
});

